import React, { useEffect, useState } from "react";
import client from "@/lib/apiClient";
import { useLang } from "@/i18n";
import { SectionHeader, Loader, Lu } from "@/components/shared";

const ROLE_META = {
  super_admin: { color: "#1E5EFF", icon: "shield", ar: "إدارة النظام", en: "Super Admin" },
  owner: { color: "#F59E0B", icon: "crown", ar: "مالك", en: "Owner" },
  manager: { color: "#3B82F6", icon: "briefcase", ar: "مدير", en: "Manager" },
  housekeeping: { color: "#10B981", icon: "brush-cleaning", ar: "تدبير فندقي", en: "Housekeeping" },
  guest: { color: "#64748B", icon: "bed-single", ar: "ضيف", en: "Guest" },
};

export default function Users() {
  const { t, lang } = useLang();
  const [users, setUsers] = useState(null);
  useEffect(() => { client.get("/users").then((r) => setUsers(r.data)); }, []);
  if (!users) return <Loader />;

  return (
    <div>
      <SectionHeader icon="user-cog" title={t("users")} subtitle={`${users.length} users`} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {users.map((u) => {
          const rm = ROLE_META[u.role] || ROLE_META.guest;
          return (
            <div key={u.email} data-testid={`user-${u.role}`} className="md-card p-5 flex items-center gap-4">
              <div className="w-12 h-12 rounded-full flex items-center justify-center shrink-0 font-bold text-lg"
                style={{ background: `${rm.color}22`, color: rm.color }}>{(u.name || "U")[0]}</div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-foreground truncate">{u.name}</p>
                <p className="text-xs text-muted-foreground/70 truncate">{u.email}</p>
              </div>
              <span className="text-xs px-2.5 py-1 rounded-full flex items-center gap-1.5 shrink-0"
                style={{ color: rm.color, background: `${rm.color}1a` }}>
                <Lu name={rm.icon} className="w-3 h-3" />{rm[lang]}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
